import de from './de.json';
import en from './en.json';
import pl from './pl.json';
import ru from './ru.json';
import uk from './uk.json';

// Extra typing is necessary to check is all localizations has the same fields
export const localizationResources: Record<string, typeof uk & typeof ru & typeof en & typeof de & typeof pl> = {
	uk,
	ru,
	en,
	de,
	pl,
};
